const hasOwnProperty = Object.prototype.hasOwnProperty
export const hasOwn = (obj, key) => {
  return hasOwnProperty.call(obj, key)
}
export const isUndef = v => {
  return v === undefined || v === null
}
export const isFunction = v => {
  return typeof v === 'function'
}
/**
 *
 * @param data
 * @param keyMap
 * @return {{}}
 */
export const linq = (data, keyMap) => {
  const info = Object.keys(keyMap).reduce((prevInfo, key) => {
    const keyValue = keyMap[key]
    if (isFunction(keyValue)) {
      prevInfo[key] = keyValue(data)
    } else if (!isUndef(data[keyValue])) {
      prevInfo[key] = data[keyValue]
    }
    return prevInfo
  }, {})
  return info
}
export const arrayfy = list => {
  if (!Array.isArray(list)) {
    return [list]
  }
  return list
}
